import { useUpdateProfileMutation } from "../app/auth/auth-slice"
import { useAppState } from "./use-app-state"

export const useUpdateProfileData = () => {
  const { user } = useAppState()
  const [updateProfile] = useUpdateProfileMutation({})

  const update = async (value: any) => {
    await updateProfile({
      data: { data: { ...user.data, ...value } },
      uid: user.uid,
    })
  }

  return { update }
}
